module.exports = __webpack_public_path__ + "img/fiskeri_akvakultur_med_paavirkningsgrad.b6163078.jpg";